import { type ICol } from "src/interfaces";
import { type IOzoneItem } from "src/pages/Settings/YachtSetup/OzoneDepletingSubstances/OzoneDepletingSubstances.types";
import { validateDate } from "src/utils";
import { v4 } from "uuid";
/**
 * Generates a filled row object based on the provided columns and item data.
 *
 * @param cols - An array of column definitions.
 * @param item - An object containing data to populate the row.
 * @returns An object representing a filled row with updated column values.
 */
export const getFilledRow = (cols: Record<string, ICol>, item: IOzoneItem) => {
  const fields: Array<keyof IOzoneItem> = ["name", "man", "loc", "date"];
  const newCols: Record<string, any> = {};
  Object.values(cols).forEach(col => {
    let value;
    if (col.tag && fields.includes(col.tag as keyof IOzoneItem)) {
      value = item[col.tag as keyof IOzoneItem];
    }
    if (value && col.tag === "date") {
      const date = validateDate(item.date);
      console.log({
        value,
        date,
        year: date ? String(date.getFullYear()) : "",
      });

      value = date ? String(date.getFullYear()) : "";
    }
    newCols[v4()] = { ...col, value };
  });
  return { cols: newCols };
};
/**
 * Generates a new empty row object based on the provided columns.
 *
 * @param cols - An array of column definitions.
 * @returns An object representing a new empty row with blank column values.
 */
export const getNewEmptyRow = (cols: Record<string, ICol>) => {
  const newCols: Record<string, ICol> = {};
  Object.values(cols).forEach((col, index) => {
    newCols[v4()] = { ...col, value: "" };
  });
  return { cols: newCols };
};
